import {
  Checkbox as HUCheckbox,
  CheckboxProps,
  Field as HUField,
  Label,
} from '@headlessui/react'
import styled from 'styled-components'

const CheckboxContainer = styled.div`
  display: flex;
`

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 3px;
  width: 14px;
  height: 16px;
`

const StyledCheckbox = styled.div<{ checked: boolean }>`
  display: inline-block;
  width: 18px;
  height: 18px;
  background: ${({ checked, theme }) =>
    checked ? theme.colors.primary.main : theme.colors.common.white};
  border-radius: 3px;
  border: ${({ checked, theme }) =>
    `1.5px solid ${checked ? theme.colors.primary.main : theme.colors.common.black75}`};
  transition: all 150ms;
  font-style: normal;
  font-weight: 200;
  font-size: 18px;
  line-height: 21px;
  text-align: center;

  ${Icon} {
    visibility: ${(props) => (props.checked ? 'visible' : 'hidden')};
  }
`

const Field = styled(HUField)`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const Checkbox = ({
  id,
  label,
  ...props
}: { label?: string } & CheckboxProps) => (
  <Field>
    <HUCheckbox {...props} id={id}>
      {({ checked }) => (
        <CheckboxContainer>
          <StyledCheckbox checked={checked}>
            <Icon viewBox="0 0 24 24">
              <polyline points="20 6 9 17 4 12" />
            </Icon>
          </StyledCheckbox>
        </CheckboxContainer>
      )}
    </HUCheckbox>
    <Label>{label}</Label>
  </Field>
)
